'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import { CatalogRequestParams } from '@/src/lib/category/types.ts';
import { SelectOption } from '@/src/types/select-option.ts';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
import Select from '@/src/app/components/Select/Select.tsx';
type SortSelectProps = {
  sortOptions: Array<SelectOption>;
  dict: Dictionary;
  selectedOption: string;
  onChange: (option: SelectOption, searchParam: CatalogRequestParams) => void;
};
function SortSelect(t0) {
  const $ = _c(8);
  const {
    sortOptions,
    dict,
    selectedOption,
    onChange
  } = t0;
  const {
    isPending
  } = useContext(LayoutTemplateContext);
  let t1;
  if ($[0] !== onChange) {
    t1 = option => onChange(option, CatalogRequestParams.SORT);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dict.category.sortBy || $[3] !== isPending || $[4] !== selectedOption || $[5] !== sortOptions || $[6] !== t1) {
    t2 = <Select value={selectedOption} options={sortOptions} label={dict.category.sortBy} placeholder={dict.category.sortBy} name="sort-category" className="w-1/2 lg:min-w-[10.875rem]" disabled={isPending} onSelectionChangeHook={t1} />;
    $[2] = dict.category.sortBy;
    $[3] = isPending;
    $[4] = selectedOption;
    $[5] = sortOptions;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export default SortSelect;